import { Avatar as AvatarPrimitive } from 'radix-ui';
import { cn } from '../lib/cn';

const sizes = { sm: 'size-6 text-2xs', md: 'size-8 text-xs', lg: 'size-12 text-base' };

/** Initials of the first and last word, e.g. "Mia Mitarbeiterin" → "MM". */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

export interface AvatarProps {
  name: string;
  src?: string;
  size?: keyof typeof sizes;
  className?: string;
}

/** Picture or initials of a person. Decorative: the name always stands next to it. */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-line bg-sunken font-semibold text-fg-muted select-none',
        sizes[size],
        className,
      )}
    >
      {src && <AvatarPrimitive.Image src={src} alt="" className="size-full object-cover" />}
      <AvatarPrimitive.Fallback>{initials(name)}</AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
